import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@ls-commons/auth/services';
import { Installation } from '@ls-commons/models';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InstallationService {
  authService = inject(AuthService);
  readonly router = inject(Router);

  constructor(private readonly http: HttpClient) {}
  urlGet = '{API}/v2/installations/all';
  urlPost = '{API}/v1/installation/add';
  urlPut = '{API}/v1/installation';
  currentUser = computed(() => this.authService.currentUser());
  currentUserId = this.currentUser()?.id || 0;

  createInstallation(data: any) {
    const body = { ...data, user_id: this.currentUserId };
    return this.http.post<any>(`{API}/v1/installation/add`, body);
  }

  getInstallationsByCurrentUser(): Observable<Installation[]> {
    return this.http
      .get<Installation[]>(`{API}/v2/installation/user/${this.currentUserId}`)
      .pipe(
        catchError(error => {
          console.error('Error al recuperar listado:', error);
          return throwError(() => error);
        })
      );
  }

  getInstallations(): Observable<any> {
    return this.http.get<any>(this.urlGet).pipe(
      catchError(error => {
        console.log('Error recibido:', error);
        if (error.status === 403) {
          console.log('Redirigiendo a error-404');
          this.router.navigate(['/error-404']);
        }
        return throwError(() => error);
      })
    );
  }
  /**
   * TS-340: contadores de sensores online/offline de la instalación (para
   * el KPI de "Salud Operativa" de la Sidebar) -- `data` viene `null` si
   * check-onlines todavía no ha calculado nada para esa instalación
   * (desactivado, o instalación recién dada de alta), no es un error.
   */
  getOnlineStats(installationId: number): Observable<any> {
    return this.http.get<any>(
      `{API}/v2/installation/${installationId}/online-stats`
    );
  }

  getInstallationById(id: any): Observable<any> {
    return this.http.get<any>(`${this.urlPut}/${id}`).pipe(
      catchError(error => {
        console.log('Error recibido:', error);
        if (error.status === 403) {
          console.log('Redirigiendo a error-404');
          this.router.navigate(['/error-404']);
        }
        return throwError(() => error);
      })
    );
  }
  addInstallation(data: FormData): Observable<any> {
    data.append('user_id', this.currentUserId.toString());

    return this.http.post<any>(this.urlPost, data).pipe(
      catchError(error => {
        console.error('Error fetching alarms:', error);
        return throwError(error);
      })
    );
  }

  editInstallation(data: FormData): Observable<any> {
    return this.http.put<any>(`${this.urlPut}/${data.get('id')}`, data).pipe(
      catchError(error => {
        console.error('Error occurred during update:', error);
        return throwError(() => error);
      })
    );
  }

  deleteInstallation(id: number): Observable<any> {
    return this.http.delete<void>(`${this.urlPut}/${id}`).pipe(
      catchError(error => {
        console.error('Error occurred during update:', error);
        return throwError(() => error);
      })
    );
  }
}
